import { render } from "./toastList.vue?vue&type=template&id=5e5fbd67&scoped=true"
import script from "./toastList.vue?vue&type=script&lang=js"
export * from "./toastList.vue?vue&type=script&lang=js"

import "./toastList.vue?vue&type=style&index=0&id=5e5fbd67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5fbd67"]])

export default __exports__